<template>
  <section class="coupon_edit">
    <el-form ref="editDataRefCoupon" :model="editData" label-width="100px">
      <el-row style="text-align: left">
        <el-col :span="24">
          <el-form-item label="背景色">
            <el-color-picker v-model="editData.backgroundColor"></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="选择优惠券:">
            <el-select v-model="editData.couponTypeId" filterable remote reserve-keyword placeholder="请输入关键词"
              :remote-method="remoteMethod" @change="couponChange">
              <el-option v-for="item in couponList" :key="item.couponTypeId" :label="item.couponName" :value="item.couponTypeId" >
                  <span>{{ item.couponTypeId}}</span>
                  <span>-</span>
                  <span>{{ item.couponName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </section>
</template>

<script type="text/babel">
import { getCouponList } from '@/api/mobile'
import { isNull, debounce } from '@/utils/validateBase'

export default {
  name: 'coupon-edit',
  props: {
    editData: {},
  },
  data() {
    return {
      // SYSTEM_UPLOAD_URL: SYSTEM_UPLOAD_URL,
      backgroundimg: require('@/assets/images/backgroundimg.png'),
      couponId: null,
      couponList: []
    }
  },

  mounted() {
  },
  methods: {
    remoteMethod: debounce(async function (query) {
      let params = { pageIndex:1,pageSize:100,condition:query }
      let {code,data} = await getCouponList(params)
      if(code === 200){
        this.couponList = data.records || []
      }
    }),
    couponChange(val) {
      let couponObj = this.couponList.find(item => item.couponTypeId === val)
      this.editData.data = couponObj
      this.editData.rowCount = 1
    },
  }
}
</script>

<style lang="scss" scoped>
.img_edit {
  font-size: 14px;
}

.checked__color {
  border: 1px solid #409EFF !important;
}

.img_edit__img {
  height: 98px;
  width: 98px;
  border: 1px solid #c4c4c4;
  cursor: pointer;
  margin-right: 10px;
}

.addImg {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #409EFF;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border: 1px dashed #409EFF;
  line-height: 90px;
  text-align: center;
}

.avatar {
  width: 268px;
  height: 100px;
  display: block;
}

.backgroundColor__img {
  width: 120px;
  height: 84px;
  margin-left: 17px
}

.backgroundColor {
  width: 355px;
  height: 84px;
  position: relative;
}

.backgroundColor::before {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0px;
  width: 100%;
  height: 10px;
  background-image: radial-gradient(circle, #fff, #fff 4px, transparent 0px, transparent 2px, transparent 22px, transparent);
  background-size: 10px 10px;
  background-repeat: repeat-x;
}
</style>
